import { generatePath } from "react-router";

// App
import { appendUrlParams, fetchDelete, fetchGet, fetchPatch, fetchPost } from "../../../utilities";
import {
  URI_ORGANIZATION,
  URI_ORGANIZATION_ADD,
  URI_ORGANIZATION_DELETE,
  URI_ORGANIZATION_EDIT,
  URI_ORGANIZATION_FORM,
} from "../constants/uris";

// Organization
import {
  ORGANIZATION_FORM_CLEAR,
  ORGANIZATION_FORM_FETCH_REQUEST,
  ORGANIZATION_FORM_FETCH_RESPONSE_ERROR,
  ORGANIZATION_FORM_FETCH_RESPONSE_SUCCESS,
  ORGANIZATION_FORM_INIT_REQUEST,
  ORGANIZATION_FORM_INIT_RESPONSE_ERROR,
  ORGANIZATION_FORM_INIT_RESPONSE_SUCCESS,
  ORGANIZATION_FORM_SUBMIT_REQUEST,
  ORGANIZATION_FORM_SUBMIT_RESPONSE_ERROR,
  ORGANIZATION_FORM_SUBMIT_RESPONSE_SUCCESS,
  ORGANIZATION_GRID_CHANGE_FILTER,
  ORGANIZATION_GRID_CHANGE_PAGINATION,
  ORGANIZATION_GRID_CHANGE_SORT,
  ORGANIZATION_GRID_DELETE_REQUEST,
  ORGANIZATION_GRID_DELETE_RESPONSE_ERROR,
  ORGANIZATION_GRID_DELETE_RESPONSE_SUCCESS,
  ORGANIZATION_GRID_FETCH_REQUEST,
  ORGANIZATION_GRID_FETCH_RESPONSE_ERROR,
  ORGANIZATION_GRID_FETCH_RESPONSE_SUCCESS,
} from "../constants/actionTypes";

// FORM - Clear
export const formClear = () => {
  return (dispatch) => {
    dispatch({
      type: ORGANIZATION_FORM_CLEAR,
    });
  };
};

// FORM - Fetch
export const formFetch = (id) => {
  return async (dispatch, getState) => {
    const state = getState();

    if (false === state.organization.formIsFetching) {
      dispatch({
        type: ORGANIZATION_FORM_FETCH_REQUEST,
      });

      await fetchGet(generatePath(URI_ORGANIZATION_EDIT, { id: id }))
        .then((res) => {
          if (res.ok) {
            dispatch({
              type: ORGANIZATION_FORM_FETCH_RESPONSE_SUCCESS,
              payload: res.body,
            });
          } else {
            dispatch({
              type: ORGANIZATION_FORM_FETCH_RESPONSE_ERROR,
              payload: res.body,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ORGANIZATION_FORM_FETCH_RESPONSE_ERROR,
            payload: [err.message],
          });
        });
    }
  };
};

// FORM - Init
export const formInit = (data, id = null) => {
  return async (dispatch, getState) => {
    const state = getState();

    if (false === state.organization.formIsInitializing) {
      dispatch({
        type: ORGANIZATION_FORM_INIT_REQUEST,
      });

      if (null === id) {
        id = 0;
      }

      await fetchPost(generatePath(URI_ORGANIZATION_FORM, { id: id }), data)
        .then((res) => {
          if (res.ok) {
            dispatch({
              type: ORGANIZATION_FORM_INIT_RESPONSE_SUCCESS,
              payload: res.body,
            });
          } else {
            dispatch({
              type: ORGANIZATION_FORM_INIT_RESPONSE_ERROR,
              payload: res.body,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ORGANIZATION_FORM_INIT_RESPONSE_ERROR,
            payload: [err.message],
          });
        });
    }
  };
};

// FORM - Submit - Create
export const formSubmitCreate = (data) => {
  return async (dispatch) => {
    dispatch({
      type: ORGANIZATION_FORM_SUBMIT_REQUEST,
    });

    await fetchPost(URI_ORGANIZATION_ADD, data)
      .then((res) => {
        if (res.ok) {
          dispatch({
            type: ORGANIZATION_FORM_SUBMIT_RESPONSE_SUCCESS,
            payload: res.body,
          });
        } else {
          dispatch({
            type: ORGANIZATION_FORM_SUBMIT_RESPONSE_ERROR,
            payload: res.body,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ORGANIZATION_FORM_SUBMIT_RESPONSE_ERROR,
          payload: [err.message],
        });
      });
  };
};

// FORM - Submit - Update
export const formSubmitUpdate = (data, id) => {
  return async (dispatch) => {
    dispatch({
      type: ORGANIZATION_FORM_SUBMIT_REQUEST,
    });

    await fetchPatch(generatePath(URI_ORGANIZATION_EDIT, { id: id }), data)
      .then((res) => {
        if (res.ok) {
          dispatch({
            type: ORGANIZATION_FORM_SUBMIT_RESPONSE_SUCCESS,
            payload: res.body,
          });
        } else {
          dispatch({
            type: ORGANIZATION_FORM_SUBMIT_RESPONSE_ERROR,
            payload: res.body,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ORGANIZATION_FORM_SUBMIT_RESPONSE_ERROR,
          payload: [err.message],
        });
      });
  };
};

// GRID - Change - Filter
export const gridChangeFilter = (filters) => {
  return (dispatch) => {
    dispatch({
      type: ORGANIZATION_GRID_CHANGE_FILTER,
      payload: {
        filters: filters,
      },
    });
  };
};

// GRID - Change - Pagination
export const gridChangePagination = (page, pageSize) => {
  return (dispatch) => {
    dispatch({
      type: ORGANIZATION_GRID_CHANGE_PAGINATION,
      payload: {
        page: page,
        pageSize: pageSize,
      },
    });
  };
};

// GRID - Change - Sort
export const gridChangeSort = (sortField, sortOrder) => {
  return (dispatch) => {
    dispatch({
      type: ORGANIZATION_GRID_CHANGE_SORT,
      payload: {
        sortField: sortField,
        sortOrder: sortOrder,
      },
    });
  };
};

// GRID - Delete
export const gridDelete = (id) => {
  return async (dispatch) => {
    dispatch({
      type: ORGANIZATION_GRID_DELETE_REQUEST,
    });

    await fetchDelete(generatePath(URI_ORGANIZATION_DELETE, { id: id }))
      .then((res) => {
        if (res.ok) {
          dispatch({
            type: ORGANIZATION_GRID_DELETE_RESPONSE_SUCCESS,
            payload: res.body,
          });
        } else {
          dispatch({
            type: ORGANIZATION_GRID_DELETE_RESPONSE_ERROR,
            payload: res.body,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: ORGANIZATION_GRID_DELETE_RESPONSE_ERROR,
          payload: [err.message],
        });
      });
  };
};

// GRID - Fetch
export const gridFetch = () => {
  return (dispatch, getState) => {
    const state = getState();

    if (false === state.organization.gridIsFetching) {
      dispatch({
        type: ORGANIZATION_GRID_FETCH_REQUEST,
      });

      const urlParams = appendUrlParams(
        state.organization.gridFilters,
        state.organization.gridPage,
        state.organization.gridPageSize,
        state.organization.gridSortField,
        state.organization.gridSortOrder
      );

      fetchGet(URI_ORGANIZATION + urlParams)
        .then((res) => {
          if (res.ok) {
            dispatch({
              type: ORGANIZATION_GRID_FETCH_RESPONSE_SUCCESS,
              payload: res.body,
            });
          } else {
            dispatch({
              type: ORGANIZATION_GRID_FETCH_RESPONSE_ERROR,
              payload: res.body,
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ORGANIZATION_GRID_FETCH_RESPONSE_ERROR,
            payload: [err.message],
          });
        });
    }
  };
};
